export default __webpack_public_path__ + "static/media/apiGreen.dd62ad7e.svg";